/**
 * Product Clicks API — POST /products/clicks
 */

import { BaseApi } from "./base.api";
import { LOS_API_BASE_URL } from "@/config";
import type {
  GetProductClicksRequest,
  GetProductClicksResponse,
} from "@/types/productClicks.types";

export class ProductClicksApi extends BaseApi {
  constructor() {
    super(LOS_API_BASE_URL);
  }

  async getProductClicks(
    request: GetProductClicksRequest
  ): Promise<GetProductClicksResponse> {
    try {
      const response = await this.post<GetProductClicksResponse>(
        "/products/clicks",
        request,
        true
      );

      if (response.success && response.data) {
        return response.data;
      }

      return {
        message: response.message || "Failed to fetch product clicks",
        response: [],
      };
    } catch (error) {
      const apiError = this.handleError(error);
      return {
        message:
          apiError.message ||
          "Failed to fetch product clicks. Please try again.",
        response: [],
      };
    }
  }
}

export const productClicksApi = new ProductClicksApi();
